import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import "../styles/style.scss"

const MenuIndex = ({ data, location }) => {
  const posts = data.allContentfulMenuSection.edges

  return (

    <Layout location={location} title={data.contentfulGeneralSettings.siteTitle}>

      <SEO title={data.contentfulGeneralSettings.siteTitle} />

      {posts.map(({ node }) => {

        return (
          <div className="menu-single" key={node.slug}>
            <Link style={{
              boxShadow: `none`,
              color: `inherit`,
            }} to={node.slug}>
              <span class="menu-button">{node.menuTitle}</span>
            </Link>
          </div>


        )
      })}
    </Layout>
  )
}

export default MenuIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulMenuSection {
      edges {
        node {
          menuTitle
          slug
        }
      }
    }
    contentfulGeneralSettings(id: {eq: "19166788-9620-5ff1-a67e-af5545ca9bca"}) {
      id
      siteTitle
      address
      logo {
        fluid {
          src
        }
      }
    }
  }
`
